import React, { createContext, useContext, useEffect, useState } from 'react';
import {
  CHEAPEST,
  MEMBER_PRICE_POLICY_DISCOUNTED,
  MEMBER_PRICE_POLICY_DISCOUNTED_PLUS_COUPON,
  MEMBER_PRICE_POLICY_UNDISCOUNTED,
} from '../../components/Shared/FeeSelector/FeeTypeName/feeTypeConstantNames';
import { useDefaultFeeType } from 'clientState/providers/SearchResponseProvider';
import { usePriceTypeFilterTimeMetric } from 'clientState/hooks/metrics';
import { useSemDefaultFeeType } from './SEM/SemResponseProvider';

const loadingContextValue = [null, () => {}];

const FeeRequestContext = createContext(loadingContextValue);

export const useFeeType = () => {
  const [feeType, setFeeType] = useContext(FeeRequestContext);
  const { start } = usePriceTypeFilterTimeMetric();
  const defaultFeeType = useDefaultFeeType();
  const semDefaultFeeType = useSemDefaultFeeType();
  const selectedFeeType = feeType || defaultFeeType || semDefaultFeeType;
  if (!selectedFeeType) {
    return loadingContextValue;
  }
  const applyFeeType = (feeType) => {
    start();
    setFeeType(feeType);
  };
  return [selectedFeeType, applyFeeType];
};

const parseFeeType = (feeType) => {
  const id = feeType?.id;
  return {
    id: id === CHEAPEST ? '0' : id,
  };
};
const isPrimeFeeType = ({ id }) =>
  [
    MEMBER_PRICE_POLICY_DISCOUNTED,
    MEMBER_PRICE_POLICY_UNDISCOUNTED,
    MEMBER_PRICE_POLICY_DISCOUNTED_PLUS_COUPON,
  ].includes(id);

const FeeTypeProvider = ({ onChange, children }) => {
  const stateAndDispatch = useState(null);
  const [feeType] = stateAndDispatch;

  useEffect(() => {
    const parsedFeeType = parseFeeType(feeType);
    if (parsedFeeType.id && !isPrimeFeeType(parsedFeeType)) {
      onChange(parsedFeeType);
    }
  }, [feeType, onChange]);

  return (
    <FeeRequestContext.Provider value={stateAndDispatch}>
      {children}
    </FeeRequestContext.Provider>
  );
};

export default FeeTypeProvider;
